/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Scope_Team_HintInputs */



/**
* | output |
* | --- |
* | "Only members of the teams you pick can see and use this persona." |
*
* @param {Personas_Scope_Team_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_scope_team_hint = /** @type {((inputs?: Personas_Scope_Team_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Scope_Team_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Mitglieder der ausgewählten Teams sehen und nutzen diese Persona.")
	return /** @type {LocalizedString} */ ("Only members of the teams you pick can see and use this persona.")
});